<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import AdminDashboard from '@/views/Pages/Admin/DashboardView.vue'
import AgentDashboard from '@/views/Pages/Agent/DashboardView.vue'
import EngineerDashboard from '@/views/Pages/Engineer/DashboardView.vue'
import ClientDashboard from '@/views/Pages/Client/DashboardView.vue'
import UnauthorizedView from '@/views/Pages/UnauthorizedView.vue'

const authStore = useAuthStore()

// Use userType instead of role
const userType = computed(() => authStore.user?.userType || '')
</script>

<template>
  <!-- Admin Dashboard -->
  <AdminDashboard 
    v-if="userType === 'admin'" 
  />
  
  <!-- Agent Dashboard -->
  <AgentDashboard 
    v-else-if="userType === 'agent'" 
  />
  
  <!-- Engineer Dashboard -->
  <EngineerDashboard 
    v-else-if="userType === 'engineer'" 
  />
  
  <!-- Client Dashboard -->
  <ClientDashboard 
    v-else-if="userType === 'client'" 
  />
  
  <!-- Unauthorized Access -->
  <UnauthorizedView v-else />
</template>